import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';

import { Message } from '../shared/models';
import { ConfirmationModalComponent, ModalService } from '../shared/modules/modal';
import { ComponentCanDeactivate } from '../shared/interfaces/component-can-deactivate.interface';
import { TranslationConstants } from '../shared/constants/translation';

@Injectable()
export class CanDeactivateGuard implements CanDeactivate<ComponentCanDeactivate> {

  constructor(private _modalService: ModalService) {}

  canDeactivate(component: ComponentCanDeactivate): Promise<boolean> {
    return new Promise((resolve) => {
      if (component.canDeactivate()) {
        this._modalService.openModal({
          component: ConfirmationModalComponent,
          data: {
            title: TranslationConstants.GLOBAL_LEAVE,
            content: TranslationConstants.GLOBAL_LEAVE_CONTENT,
          } as Message,
          success: () => {
            resolve(true);
          },
          cancel: () => {
            resolve(false);
          },
        });
      } else {
        resolve(true);
      }
    });
  }
}
